

















import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    ref,
    Ref,
    watch,
} from '@vue/composition-api';

import { errorGuard } from '@core/utils/ErrorGuard';
import HotTournamentsCarousel from '@modules/sportOffer/hotTournaments/HotTournamentsCarousel.vue';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import { CategoryWithCompetitions } from '@core/models/struct/CategoryWithCompetitions';

import SportCompetitionsBase from './SportCompetitionsBase.vue';

export default defineComponent({
    name: 'SportCompetitions',
    props: {
        sportId: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const isLoading = ref(false);
        const sportOfferStore = useVuexStore<SportOfferDataStore>('data/sportOffer');

        const getCompetitionsBySportId = sportOfferStore.getter('getCompetitionTreeBySportId');
        const fetchCompetitionsBySportId = sportOfferStore.action('fetchCompetitionTreeBySportId');

        const competitions: Ref<CategoryWithCompetitions[]> = computed(() => getCompetitionsBySportId.value(props.sportId));

        watch(
            () => props.sportId,
            async (newSportId, oldSportId) => {
                if (newSportId === oldSportId) {
                    return;
                }
                isLoading.value = true;
                await errorGuard(() => fetchCompetitionsBySportId({ sportId: props.sportId }));
                isLoading.value = false;
            },
            {
                immediate: true,
            },
        );

        return {
            isLoading,
            competitions,
        };
    },
    components: {
        HotTournamentsCarousel,
        SportCompetitionsBase,
    },
});
